const baseURL = 'https://thomswatches.com/';

export default baseURL;
